import type { FC, InputHTMLAttributes } from "react";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "../ui/form";
import { useWatch } from "react-hook-form";
import { Input } from "../ui/input";
import type { InputProps } from "~/utils/types";

interface ExtendedInputProps extends InputProps, Omit<InputHTMLAttributes<HTMLInputElement>, "name" | "onChange"> {
  inputClassName?: string;
  labelAsPlaceholder?: boolean;
}

const TextFormInput: FC<ExtendedInputProps> = ({ label, name, helperText, labelAsPlaceholder, ...rest }) => {
  const value = useWatch({ name });

  return (
    <FormField
      name={name}
      render={({ field }) => {
        return (
          <FormItem>
            {!labelAsPlaceholder && <FormLabel>{label}</FormLabel>}
            <FormControl>
              <Input
                placeholder={labelAsPlaceholder ? (label as string) : undefined}
                {...rest}
                {...field}
                value={value}
                onChange={(e) => {
                  rest.onChange?.(e);
                  field.onChange?.(e);
                }}
              />
            </FormControl>
            {helperText && <FormDescription>{helperText}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};

export { TextFormInput };
